/* @flow */
import * as React from 'react';
import { graphql, compose } from 'react-apollo';

import { OPTIONS } from 'phoneCalls/components/PhoneCallNoteForm';
import Heading from 'components/Heading';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import ModalTrigger from 'components/ModalTrigger';
import PHONE_CALL_NOTE_QUERY from 'phoneCalls/queries/PhoneCallMessageItemNoteQuery.gql';
import PhoneCallNoteModal from 'phoneCalls/components/PhoneCallNoteModal';
import Row from 'components/Row';
import Text from 'components/Text';

import type { PhoneCallMessageItemNote as PhoneCallMessageItemNoteData } from 'phoneCalls/queries/__generated__/PhoneCallMessageItemNote';

import './styles/MessageItem.scss';

type Props = PhoneCallMessageItemNoteData;

class PhoneCallMessageItemNote extends React.Component<Props> {
  render() {
    const { phoneCall } = this.props;

    if (!phoneCall) {
      return null;
    }

    const { note, reasons } = phoneCall;

    if (!reasons) {
      // schema says reasons may be null
      return null;
    }

    // $FlowFixMe our schema says the elements of `reasons` array can be null
    const reasonsFormatted = reasons.map(reason => OPTIONS.get(reason));

    if (note || reasons.length) {
      return (
        <ModalTrigger modal={<PhoneCallNoteModal uuid={phoneCall.uuid} />}>
          <div className="MessageItemContent-note">
            <Row size="xsmall">
              <MediaObject center figure="left" gutter="xsmall">
                <Heading level="3" flush>
                  Notes
                </Heading>
                <Text color="graphite" size="xsmall" italic>
                  Only you can see this
                </Text>
              </MediaObject>
            </Row>
            <Text color="graphite" size="small">
              {reasonsFormatted.length > 0 ? (
                <Text color="chalkboard" weight="semibold">
                  {reasonsFormatted.join(', ')}
                </Text>
              ) : null}
              {reasonsFormatted.length && note ? <br /> : null}
              {note}
            </Text>
          </div>
        </ModalTrigger>
      );
    } else {
      return (
        <ModalTrigger modal={<PhoneCallNoteModal uuid={phoneCall.uuid} />}>
          <Link className="MessageItem-phoneCallCTA">
            <Text size="small" align="center">
              Take notes
            </Text>
          </Link>
        </ModalTrigger>
      );
    }
  }
}

const withPhoneCall = graphql(PHONE_CALL_NOTE_QUERY, {
  options: ({ uuid }) => ({ variables: { uuid } }),
  props: ({ data }) => data,
});

export { PhoneCallMessageItemNote };

export default compose(withPhoneCall)(PhoneCallMessageItemNote);
